import * as pdfJs from 'pdfjs-dist';
// import * as pdfWorker from './pdf.worker.min.mjs';

export async function pdfToImage(
  src: string | ArrayBuffer | Uint8Array,
  format = 'image/png',
  quality = 0.92
): Promise<string[]> {
  // Support either a URL string (fetched) or raw data (ArrayBuffer/Uint8Array)
  let existingPdfBytes: ArrayBuffer;
  if (typeof src === 'string') {
    existingPdfBytes = await fetch(src).then(res => res.arrayBuffer());
  } else if (src instanceof Uint8Array) {
    existingPdfBytes = src.slice().buffer;
  } else {
    // assume ArrayBuffer
    existingPdfBytes = src as ArrayBuffer;
  }

  const fileArray = new Uint8Array(existingPdfBytes);

  const anyPdf: any = pdfJs;
  const version = anyPdf.version || '5.4.624';
  const pdfWorkerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.mjs`;
  if (
    anyPdf?.GlobalWorkerOptions &&
    !anyPdf.GlobalWorkerOptions.workerSrc &&
    !anyPdf.GlobalWorkerOptions.workerPort
  ) {
    try {
      if (pdfWorkerSrc) {
        if (typeof pdfWorkerSrc === 'string') {
          anyPdf.GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
        } else if (typeof (pdfWorkerSrc as any)?.default === 'string') {
          anyPdf.GlobalWorkerOptions.workerSrc = (pdfWorkerSrc as any).default;
        } else {
          const WorkerCtor = (pdfWorkerSrc as any).default || pdfWorkerSrc;
          if (typeof WorkerCtor === 'function') {
            const workerInstance = new (WorkerCtor as any)();
            anyPdf.GlobalWorkerOptions.workerPort = workerInstance;
          } else {
            throw new Error('local pdf.worker import has unknown shape');
          }
        }
      }
    } catch (e) {
      const version = anyPdf.version || '5.4.624';
      anyPdf.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
    }
  }

  const doc = await pdfJs.getDocument({data: fileArray, useSystemFonts: true})
    .promise;

  const pages: string[] = [];
  const TARGET_LONG_EDGE = 4096;

  for (let i = 1; i <= doc.numPages; i++) {
    const page = await doc.getPage(i);
    const baseViewport = page.getViewport({scale: 1});
    const maxBaseEdge = Math.max(baseViewport.width, baseViewport.height) || 1;
    const scale = TARGET_LONG_EDGE / maxBaseEdge;
    const viewport = page.getViewport({scale});

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Could not get canvas context');

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const task = page.render({canvas, viewport} as any);
    await task.promise;

    pages.push(canvas.toDataURL(format, quality));
  }

  return pages;
}
